import { useEffect, useRef, useState } from "react"
import styled, { keyframes } from "styled-components"
import { IoClose } from "react-icons/io5";

const abrirDropdown = keyframes`
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

const Container = styled.div`
    box-sizing: border-box;
    border: ${props => props.isOpen ? '2px solid #007bff' : '1px solid #ddd'};
    box-shadow: ${props => props.isOpen ? '0 0 5px rgba(0, 123, 255, 0.5)' : 'none'};
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    &:hover {
        border-color: ${props => props.isOpen ? '#007bff' : '#aaa'}; ;
    }
    position: relative;
    width: ${props => props.largura ? props.largura : '100%' };
    height: 38px;
`
const ContainerPlaceholder = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`
const Placeholder = styled.p`
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: #666;
`
const ContainerIconeClose = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px;
    width: 18px;
    margin: auto auto auto 5px;
`
const IconeClose = styled(IoClose)`
    width: 100%;
    height: 100%;
    color: #666;
    cursor: pointer;
    &:hover {
        color: #333;
    }
    margin: 0;
    padding: 0;
    box-sizing: border-box;
`
const IconeSeta = styled.span`
    border: solid #666;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    padding: 4px;
    margin: 0 5px 4px auto;
`
const Dropdown = styled.div`
    position: absolute;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    top: 39px;
    left: 0;
    z-index: 1000;
    min-width: 100%;
    max-height: 180px;
    box-sizing: border-box;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 4px;
    }
    animation: ${abrirDropdown} 0.2s ease-out;
`
const Option = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 7px 10px;
    box-sizing: border-box;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    &:last-child {
        border-bottom: none;
    }
    &:hover {
        background-color: #f5f5f5;
    }
    background-color: ${props => props.selected ? '#e6f7ff' : 'transparent'};
`
const OptionCheckbox = styled.input`
    margin-right: 10px;
`


const MultiselectCheck = ({ options, selectedOptions, setSelectedOptions, placeholder, largura }) => {

    const [isOpen, setIsOpen] = useState(false);

    const containerRef = useRef(null);

    useEffect(() => {

        function handleClickOutside(e) {

            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }

        }

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        }

    }, [])

    const toggleOption = (option) => {

        if (selectedOptions.includes(option)) {
            setSelectedOptions(selectedOptions.filter((opt) => opt !== option));
        } else {
            setSelectedOptions([...selectedOptions, option]);
        }

    }

    const isOptionSelected = (option) => {
        return selectedOptions.includes(option);
    }

    const openDropdown = () => {
        setIsOpen(!isOpen);
    }

    const dropdownClick = (e) => {
        e.stopPropagation();
    }

    useEffect(() => {

        console.log(selectedOptions);

    }, [selectedOptions])

    const selectAll = () => {

        if (selectedOptions.length === options.length) {
            setSelectedOptions([]);
        } else {
            setSelectedOptions(options.map(option => option.value));
        }

    }

    return (
        <>
            <Container ref={containerRef} onClick={openDropdown} isOpen={isOpen} largura={largura} >
                <ContainerPlaceholder>
                    <Placeholder>
                        {selectedOptions.length === 0 ? (placeholder || "TODOS") : selectedOptions.length + " SELECIONADO" + (selectedOptions.length > 1 ? "S" : "")}
                    </Placeholder> 
                </ContainerPlaceholder>
                {
                    selectedOptions.length > 0 && (
                        <ContainerIconeClose>
                            <IconeClose onClick={(e) => { e.stopPropagation(); setSelectedOptions([]); }} />
                        </ContainerIconeClose>
                    )
                }
                <IconeSeta />
                {
                    isOpen && (
                        <Dropdown onClick={dropdownClick} >
                            <Option selected={selectedOptions.length === 0 || selectedOptions.length === options.length} onClick={selectAll}>
                                <OptionCheckbox
                                    type="checkbox"
                                    checked={selectedOptions.length === 0 || selectedOptions.length === options.length}
                                    readOnly
                                />
                                TODOS
                            </Option>
                            {options.map((option, index) => (
                                <Option selected={isOptionSelected(option.value)} key={index} onClick={() => toggleOption(option.value)} >
                                    <OptionCheckbox
                                        type="checkbox"
                                        checked={isOptionSelected(option.value)}
                                        readOnly
                                    />
                                    {option.label}
                                </Option>
                            ))}
                        </Dropdown>
                    )
                }
            </Container>
        </>
    )
}

export default MultiselectCheck;